import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'
import type { RootState } from '../../redux/store'

import {
  EMPTY_STRING,
  NULL_DATE
} from '../components/global';

// Define a type for the slice state
interface AppState {
  copyright: string,
  releaseDate: Date,
  version: string
}

// Define the initial state using that type
const initialState: AppState = {
  copyright: EMPTY_STRING,
  releaseDate: NULL_DATE,
  version: EMPTY_STRING
}

export const appSlice = createSlice({
  name: 'app',
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    setCopyright: (state, action: PayloadAction<string>) => {
      state.copyright = action.payload
    },
    setReleaseDate: (state, action: PayloadAction<Date>) => {
      state.releaseDate = action.payload
    },
    setVersion: (state, action: PayloadAction<string>) => {
      state.version = action.payload
    },
  },
})

export const { setCopyright, setReleaseDate, setVersion } = appSlice.actions

// Other code such as selectors can use the imported `RootState` type
export const getCopyright = (state: RootState) => state.app.copyright;
export const getReleaseDate = (state: RootState) => state.app.releaseDate;
export const getVersion = (state: RootState) => state.app.version;

export default appSlice.reducer